import { extendTheme } from '@chakra-ui/react';
import { colors } from './foundations/colors';
import { semanticTokens } from './foundations/semanticTokens';
import { typography } from './foundations/typography';
import { shadows } from './foundations/shadows';
import { radii } from './foundations/radii';
import { Card } from './components/Card';
import { Button } from './components/Button';
import { Badge } from './components/Badge';
import { Tag } from './components/Tag';
import { Input } from './components/Input';
import { Textarea } from './components/Textarea';
import { Modal } from './components/Modal';
import { Drawer } from './components/Drawer';

export const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  colors,
  semanticTokens,
  shadows,
  radii,
  ...typography,
  components: {
    Card,
    Button,
    Badge,
    Tag,
    Input,
    Textarea,
    Modal,
    Drawer,
  },
});
